<template>
  <div class="group-rounded-box my-3 mx-4">
    <span class="title">Filters</span>

    <!-- ROW -->
    <div class="row">
      <!-- CUSTOMER SELECTION -->
      <div class="col-md-3">
        <label for="selectCustomer">Customer</label>
        <div class="position-relative">
          <el-select
            @change="triggerRefresh"
            v-model="customer"
            value-key="id"
            placeholder="Search customer"
            filterable
            :disabled="isBasketCreated"
          >
            <el-option v-for="item in customerList" :key="item.id" :label="item.name" :value="item"></el-option>
            <!-- User search resulting in no match -->
            <template #empty>No matching customer</template>
          </el-select>
        </div>
      </div>

      <!-- TERMINAL SELECTION -->
      <div class="col-md-3" :class="{ 'mt-2': $breakpoint.mdAndDown }">
        <label for="selectTerminal">Terminal</label>
        <div class="position-relative">
          <el-select
            v-model="terminal"
            @change="handleTerminal()"
            value-key="_id"
            placeholder="Search terminal"
            clearable
            filterable
            :disabled="customer == null || networks.length > 0 || isBasketCreated"
          >
            <el-option
              v-for="item in getTerminalChanges"
              :key="item._id"
              :label="item.name"
              :value="item"
            ></el-option>
            <!-- User search resulting in no match -->
            <template #empty>No matching terminal</template>
          </el-select>
        </div>
      </div>

      <!-- NETWORK SELECTION -->
      <div class="col-md-3">
        <label for="selectNetwork" :class="{ 'mt-2': $breakpoint.mdAndDown }">Networks</label>
        <div class="position-relative">
          <el-select
            class="el-olf"
            @change="handleNetworks(networks)"
            v-model="networks"
            value-key="_id"
            placeholder="Search network(s)"
            multiple
            filterable
            collapse-tags
            clearable
            :disabled="
              customer == null ||
              (products.length > 0 && !isDieselSelected(products)) ||
              terminal != null"
          >
            <el-option class="font-weight-bold" :value="SELECT_ALL"> </el-option>
            <el-option v-for="item in networksList" :key="item._id" :label="item.name" :value="item"></el-option>
            <!-- User search resulting in no match -->
            <template #empty>No matching network</template>
          </el-select>
        </div>
      </div>

      <!-- PRODUCT SELECTION -->
      <div class="col-md-3" :class="{ 'mt-2': $breakpoint.mdAndDown }">
        <label for="selectProduct">Products</label>
        <div class="position-relative">
          <el-select
            class="el-olf"
            @change="handleProducts(products)"
            v-model="products"
            value-key="_id"
            multiple
            filterable
            collapse-tags
            clearable
            placeholder="Search product(s)"
            :disabled="!isTerminalSelected || isNetworkSelected"
          >
            <el-option class="font-weight-bold" :value="SELECT_ALL"> </el-option>
            <el-option v-for="item in fuelList" :key="item._id" :label="item.name" :value="item"></el-option>
            <!-- User search resulting in no match -->
            <template #empty>No matching product</template>
          </el-select>
        </div>
      </div>
    <!-- ROW -->
    </div>
  </div>
</template>

<script>
import breakpoint from '@/mixins/index';
import { mapGetters, mapActions } from 'vuex';

export default {
  mixins: [breakpoint],
  data (){
    return {
      SELECT_ALL: "Select All",
    }
  },
  props: {
    isBasketCreated: {
      required: true,
      type: Boolean
    }
  },
  created: async function(){
    if (this.customerList.length < 1) await this.$store.dispatch('accounts/getRelationships');
    if(this.getSearchableBool){
      this.triggerRefresh();
    }
  },
  computed:{
    ...mapGetters('accounts', ['customerList']),
    ...mapGetters('fuelsType', ['getFuelsType']),
    ...mapGetters('terminals', ['getTerminalChanges']),
    ...mapGetters('metadata', ['productConfig', 'networkConfig']),
    ...mapGetters('orderCapture', ['getCustomer', 'getProducts', 'getTerminal', 'getNetworks', 'getSearchableBool']),
    fuelList:{
      get: function(){
        return this.getFuelsType.filter(product => product.type === 'SPOT');
      }
    },
    networksList:{
      get: function(){
        return this.$store.getters['metadata/networks'];
      }
    },
    products:{
      get: function(){
        return this.getProducts;
      },
      set: function(value){
        this.setProducts(value);
      }
    },
    customer:{
      get: function(){
        return this.getCustomer;
      },
      set: function(value){
        this.setCustomer(value || null);
      }
    },
    terminal:{
      get: function(){
        return this.getTerminal;
      },
      set: function(value){
        this.setTerminal(value || null);
      }
    },
    networks:{
      get: function(){
        return this.getNetworks;
      },
      set: function(value){
        this.setNetworks(value);
      }
    },
    isTerminalSelected: function() {
      return this.terminal != null;
    },
    isNetworkSelected: function() {
      return this.networks.length > 0;
    }
  },
  methods: {
    ...mapActions('orderCapture', ['setCustomer','setProducts', 'setTerminal', 'setNetworks', ]),
    triggerRefresh(){
      if (!this.isBasketCreated)
        this.$emit('refresh-offers');
    },
    handleProducts(selectedProducts) {
      if (selectedProducts.includes(this.SELECT_ALL)) {
        this.products = this.fuelList;
      }
      if (!this.isDieselSelected(selectedProducts)){
        this.networks = [];
      }
      this.triggerRefresh();
    },
    handleTerminal() {
      this.products = this.terminal != null ? this.fuelList : [];
      this.triggerRefresh();
    },
    handleNetworks(selectedNetworks) {
      if (selectedNetworks.includes(this.SELECT_ALL)) {
        this.networks = this.networksList;
      }
      if (this.isNetworkSelected){
        // Network is selected, so make sure we only select diesel in the selected products list
        const diesel = this.getFuelsType.find(product => product._id === this.productConfig.DieselId);
        if (diesel){
          this.products = [diesel];
        }
      } else {
        this.products = [];
      }
      this.triggerRefresh();
    },
    isDieselSelected: function(selectedProducts = []){
      const { DieselId } = this.productConfig;
      const selectedProductIds = selectedProducts.map(product => product._id);
      return selectedProductIds.includes(DieselId);
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
